



















import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Mutation } from 'vuex-class';
import { MutationTypes } from '@/modules/blog/store/mutations'

/**
 * Vista previa de la publicación
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class PostPreview extends Vue {

    @State(state => state.blog.currentPostPreview)
    public previewContent: string

    @State(state => state.blog.loadingPreview)
    public loading: boolean

    @Mutation(`blog/${MutationTypes.ActivePostPreview}`)
    public activePreview: (boolean: false) => void

    /**
     * Comprueba si la vista previa se encuentra activa
     *
     * @returns { boolean }
     */
    get active () {
        const isActive = this.$store.state.blog.postPreviewActive

        // Oculta la barra de scroll (si existe) del elemento principal, para que
        // no se muestren dos barras (junto con la del iframe)
        const style = isActive ? 'hidden' : 'auto'
        document.getElementsByTagName('html')[0].style.overflow = style

        return isActive
    }
}
